/**
* 图表界面
*/ 
<template>
  <!-- 组件主盒子 -->
  <div class="stbox">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 分类 -->
    <el-row :gutter="24" style="margin-right:0px">
      <el-col :span="4">
        <el-card shadow="hover" style=" height: 130px;">
          <span style="float:left">
            <img src="../../assets/img/sanitation.png" />
          </span>
          <span class="wtext">
            <h4>智能环卫</h4>
            <p>在线：{{ znhw.online }}</p>
            <p>离线：{{ znhw.offline }}</p>
          </span>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="hover" style=" height: 130px;">
          <span style="float:left">
            <img src="../../assets/img/sell.png" />
          </span>
          <span class="wtext">
            <h4>智能售卖</h4>
            <p>在线：{{ znsm.online }}</p>
            <p>离线：{{ znsm.offline }}</p>
          </span>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="hover" style=" height: 130px;">
          <span style="float:left">
            <img src="../../assets/img/inspection.png" />
          </span>
          <span class="wtext">
            <h4>智能巡检</h4>
            <p>在线：{{ znxj.online }}</p>
            <p>离线：{{ znxj.offline }}</p>
          </span>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="hover" style=" height: 130px;">
          <span style="float:left">
            <img src="../../assets/img/connect.png" />
          </span>
          <span class="wtext">
            <h4>智能接驳</h4>
            <p>在线：{{ znjb.online }}</p>
            <p>离线：{{ znjb.offline }}</p>
          </span>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="hover" style=" height: 130px;">
          <span style="float:left">
            <img src="../../assets/img/distribution.png" />
          </span>
          <span class="wtext">
            <h4>智能配送</h4>
            <p>在线：{{ znps.online }}</p>
            <p>离线：{{ znps.offline }}</p>
          </span>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card shadow="hover" style=" height: 130px;">
          <span style="float:left">
            <img src="../../assets/img/car.png" />
          </span>
          <span class="wtext">
            <h4>其他车辆</h4>
            <p>在线：{{ qtcl.online }}</p>
            <p>离线：{{ qtcl.offline }}</p>
          </span>
        </el-card>
      </el-col>
    </el-row>
    <!-- 统计图 -->
    <el-row :gutter="20" style="padding-top: 10px;">
      <el-col :span="8" class="text-c" v-loading="loading">
        <el-card shadow="hover">
          <div class="paybox">
            <div id="myChartOne"></div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="16" class="text-c" v-loading="sce">
        <el-card shadow="hover">
          <div class="st-gbox">
            <div id="myChartThree"></div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!-- 统计图 -->
    <el-row :gutter="20" style="padding-top: 10px;">
      <el-col :span="8" class="text-c" v-loading="fault">
        <el-card shadow="hover">
          <div class="paybox">
            <div id="myChartTwo"></div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="16" class="text-c" v-loading="payNum">
        <el-card shadow="hover">
          <div class="st-gbox">
            <div id="myChartFour"></div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script type="text/ecmascript-6">
import Chart from "echarts";
import {
  fault_type,
  car_status,
  car_type_online_number,
  car_mileage,
  car_type_number,
} from "../../api/index/index";
let myChartOne = null;
let myChartTwo = null;
let myChartThree = null;
let myChartFour = null;
export default {
  name: "welcome",
  data() {
    return {
      form: {
        // SanitationOn: "",
        // SanitationOff:"",
        name: "",
        online: "",
        offline: "",
      },
      znsm: {
        online: "",
        offline: "",
      },
      znxj: {
        online: "",
        offline: "",
      },
      qtcl: {
        online: "",
        offline: "",
      },
      znhw: {
        online: "",
        offline: "",
      },
      znps: {
        online: "",
        offline: "",
      },
      znjb: {
        online: "",
        offline: "",
      },
      loading: true,
      fault: true,
      sce: true,
      payNum: true,
      seriesData: [],
      carData: [],
      carType_name: [],
      carType_value: [],
      carNumber_name: [],
      carNumber_value: [],
      type: "day",
      //  里程/型号

      //  型号/数量
    };
  },
  // 导入组件
  components: {
    // 点聚合组件
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.getData();
    this.getCar();
    this.getCarType();
    this.getFault();
    this.getCarNumber();
    window.localStorage.removeItem("faultName");
    window.localStorage.removeItem("mileageName");
    window.localStorage.removeItem("carNumberName");
  },
  // 挂载结束状态(里面是操作)
  mounted() {
    this.getSCE();
    this.getClick();
    this.getpay();
    this.getpayNum();
  },
  updated() {
    setTimeout(() => {
      //设置延迟执行
      this.myChartOne.setOption({
        series: [
          {
            name: "车辆状态",
            type: "pie",
            radius: "50%",
            data: this.carData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
      this.myChartThree.setOption({
        xAxis: {
          type: "category",
          data: this.carType_name,
          axisLine: {
            lineStyle: {
              color: "#999999",
              width: 1,
            },
          },
          axisLabel: {
            margin: 14,
            height: 70,
            interval: 0,
            textStyle: {
              fontSize: 10,
              color: "#999999",
            },
          },
        },
        series: [
          {
            name: "里程/型号",
            type: "bar",
            barGap: 0,
            data: this.carType_value,
            barWidth: 10,
            itemStyle: {
              normal: {
                color: new Chart.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#83bff6" },
                  { offset: 0.5, color: "#188df0" },
                  { offset: 1, color: "#188df0" },
                ]),
              },
              emphasis: {
                color: new Chart.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#2378f7" },
                  { offset: 0.7, color: "#2378f7" },
                  { offset: 1, color: "#83bff6" },
                ]),
              },
            },
          },
        ],
      });
      this.myChartTwo.setOption({
        series: [
          {
            name: "故障分类",
            type: "pie",
            radius: "50%",
            data: this.seriesData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
      this.myChartFour.setOption({
        xAxis: {
          type: "category",
          data: this.carNumber_name,
          axisLine: {
            lineStyle: {
              color: "#999999",
              width: 1,
            },
          },
          axisLabel: {
            margin: 10,
            height: 70,
            interval: 0,
            textStyle: {
              fontSize: 10,
              color: "#999999",
            },
          },
        },
        series: [
          {
            name: "型号/数量",
            type: "bar",
            barGap: 0,
            data: this.carNumber_value,
            barWidth: 10,
            itemStyle: {
              color: "#48cefd",
            },
          },
        ],
      });
    }, 500);
  },
  // 里面的函数只有调用才会执行
  methods: {
    getData() {
      car_type_online_number().then((res) => {
        this.form = res.data;
        if (this.form) {
          this.znhw = this.form[0];
          this.znsm = this.form[1];
          this.znxj = this.form[2];
          this.znjb = this.form[3];
          this.znps = this.form[4];
          this.qtcl = this.form[5];
        }
      });
    },
    // 里程/型号
    getCarType() {
      car_mileage().then((res) => {
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            this.carType_name.push(res.data[i].name);
            this.carType_value.push(res.data[i].value);
          }
          if (this.carType_name && this.carType_value) {
            this.sce = false
          }
        }
      });
    },
    getSCE() {
      var that = this
      var myChart3 = document.getElementById("myChartThree");
      this.myChartThree = Chart.init(myChart3);
      var SCEoption;
      window.onresize = function () {
        that.myChartOne.resize();
        that.myChartTwo.resize();
        that.myChartThree.resize();
        that.myChartFour.resize();
      };
      (SCEoption = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          data: [
            {
              name: "里程/型号",
              icon: "rect",
            },
          ],
          top: 1,
          left: 1,
          itemGap: 10,
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            fontSize: 12,
            color: "#323232",
          },
        },
        grid: {
          left: 65,
          right: 10,
          top: 30,
          bottom: 30,
          borderWidth: 1,
        },
        xAxis: {
          type: "category",
          data: this.carType_name,
          axisLine: {
            lineStyle: {
              color: "#999999",
              width: 1,
            },
          },
          axisLabel: {
            margin: 14,
            height: 70,
            interval: 0,
            textStyle: {
              fontSize: 10,
              color: "#999999",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#999999",
              width: 1,
            },
          },
          axisLabel: {
            margin: 14,
            textStyle: {
              fontSize: 10,
              color: "#999999",
            },
          },
        },
        series: [
          {
            name: "里程/型号",
            type: "bar",
            barGap: 0,
            data: this.carType_value,
            barWidth: 10,
            itemStyle: {
              normal: {
                color: new Chart.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#83bff6" },
                  { offset: 0.5, color: "#188df0" },
                  { offset: 1, color: "#188df0" },
                ]),
              },
              emphasis: {
                color: new Chart.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#2378f7" },
                  { offset: 0.7, color: "#2378f7" },
                  { offset: 1, color: "#83bff6" },
                ]),
              },
            },
          },
        ],
      })
      this.myChartThree.on('click', function (params) {
        window.localStorage.setItem("mileageName", params.name);
        that.$router.push("/home_page/mileage/mileageStatistics");
      });
      SCEoption && this.myChartThree.setOption(SCEoption);
    },
    // // 交易总金额
    // getSUM() {
    //   this.chart = Chart.init(this.$refs.SUMEchart);
    //   this.chart.setOption(this.SUMoption);
    // },
    //  型号/数量
    getCarNumber() {
      car_type_number().then((res) => {
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            this.carNumber_name.push(res.data[i].name);
            this.carNumber_value.push(res.data[i].value);
          }
          if (this.carNumber_name && this.carNumber_value) {
            this.payNum = false
          }
        }
      });
    },
    getClick() {
      var that = this
      var myChart4 = document.getElementById("myChartFour");
      this.myChartFour = Chart.init(myChart4);
      var Clickoption;
      (Clickoption = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          data: [
            {
              name: "型号/数量",
              icon: "rect",
            },
          ],
          top: 1,
          left: 1,
          itemGap: 10,
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            fontSize: 12,
            color: "#323232",
          },
        },
        grid: {
          left: 50,
          right: 10,
          top: 30,
          bottom: 30,
          borderWidth: 1,
        },
        xAxis: {
          type: "category",
          data: this.carNumber_name,
          axisLine: {
            lineStyle: {
              color: "#999999",
              width: 1,
            },
          },
          axisLabel: {
            margin: 10,
            height: 70,
            interval: 0,
            textStyle: {
              fontSize: 10,
              color: "#999999",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#999999",
              width: 1,
            },
          },
          axisLabel: {
            margin: 14,
            textStyle: {
              fontSize: 10,
              color: "#999999",
            },
          },
        },
        series: [
          {
            name: "型号/数量",
            type: "bar",
            barGap: 0,
            data: this.carNumber_value,
            barWidth: 10,
            itemStyle: {
              color: "#48cefd",
            },
          },
        ],
      })
      this.myChartFour.on('click', function (params) {
        window.localStorage.setItem("carNumberName", params.name);
        that.$router.push("/home_page/carNumber");
      });
      Clickoption && this.myChartFour.setOption(Clickoption);
    },
    // // 支付方式统计
    getCar() {
      car_status().then((res) => {
        this.carData = res.data;
        if (this.carData) {
          this.loading = false
        }
      });
    },
    getpay() {
      var myChart1 = document.getElementById("myChartOne");
      this.myChartOne = Chart.init(myChart1);
      var payoption;
      (payoption = {
        // backgroundColor: "#100c2a",
        title: {
          text: "车辆状态饼状图",
          right: 10,
          top: 5,
          textStyle: {
            fontSize: 12,
            color: "#999",
          },
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },

        series: [
          {
            name: "车辆状态",
            type: "pie",
            radius: "50%",
            data: this.carData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      }),
        payoption && this.myChartOne.setOption(payoption);
    },
    // 支付方式统计
    getFault() {
      fault_type().then((res) => {
        this.seriesData = res.data;
        if (this.seriesData) {
          this.fault = false
        }
      });
    },
    getpayNum() {
      var that = this
      var myChart2 = document.getElementById("myChartTwo");
      this.myChartTwo = Chart.init(myChart2);
      var option;
      option = {
        title: {
          text: "故障分类",
          right: 10,
          top: 5,
          textStyle: {
            fontSize: 12,
            color: "#999",
          },
        },

        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "故障分类",
            type: "pie",
            radius: "50%",
            data: this.seriesData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      this.myChartTwo.on('click', function (params) {
        window.localStorage.setItem("faultName", params.name);
        that.$router.push("/home_page/faultType/homeFaultType");
      });
      option && this.myChartTwo.setOption(option);
    },
  },
};
</script>
<style>
.stbox {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.stbgc {
  background-color: #fff;
  height: 60px;
  line-height: 60px;
  border-radius: 5px;
  padding: 0px 16px;
}

.stsearch {
  text-align: center;
}

.text-c {
  text-align: center;
}

.st-gbox {
  background-color: #fff;
  border-radius: 5px;
  height: 300px;
  box-sizing: border-box;
  /* padding: 10px; */
}

#myChartOne,
#myChartThree {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

#myChartTwo,
#myChartFour {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.cavasbox {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.paybox {
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 5px;
  height: 300px;
}

.wtext {
  width: 100px;
  float: left;
  margin-left: 20px;
  margin-top: -20px;
}
</style>


// WEBPACK FOOTER //
// src/views/home_page/home_Page.vue